import { useCreatePath } from 'react-admin';
import { useRegisterBreadcrumb } from '../layout/navbar/BreadcrumbsManager';
import resourceNames from '../../constants/resourceNames';

const PermissionRolesListBreadcrumb = () => {
  const createPath = useCreatePath();
  const path = createPath({ resource: resourceNames.PERMISSION_ROLES, type: 'list' });
  useRegisterBreadcrumb({
    title: 'Permission settings',
    path,
  });

  return null;
};

export default PermissionRolesListBreadcrumb;
